var _ellipse, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.5746,
    cy: 20.3157,
    rx: 20.1519,
    ry: 20.1526,
    fill: "#9378C5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1775_11231)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.9513 15.0654C30.8285 14.575 30.5785 14.1256 30.2265 13.7627C29.8744 13.3997 29.4329 13.1362 28.9463 12.9985C27.1688 12.5645 20.0585 12.5645 20.0585 12.5645C20.0585 12.5645 12.9483 12.5645 11.1707 13.0398C10.6842 13.1775 10.2427 13.4411 9.89062 13.804C9.53859 14.1669 9.28857 14.6163 9.1658 15.1068C8.84048 16.9108 8.68135 18.7408 8.69041 20.5738C8.67881 22.4207 8.83796 24.2646 9.1658 26.0822C9.30115 26.5574 9.55677 26.9897 9.90798 27.3373C10.2592 27.6849 10.6941 27.936 11.1707 28.0664C12.9483 28.5418 20.0585 28.5418 20.0585 28.5418C20.0585 28.5418 27.1688 28.5418 28.9463 28.0664C29.4329 27.9288 29.8744 27.6652 30.2265 27.3023C30.5785 26.9394 30.8285 26.49 30.9513 25.9995C31.2741 24.2091 31.4332 22.3931 31.4267 20.5738C31.4383 18.727 31.2791 16.883 30.9513 15.0654V15.0654Z",
    stroke: "white",
    strokeWidth: 1.7524,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7333 23.9532L23.6757 20.5738L17.7333 17.1943V23.9532Z",
    stroke: "white",
    strokeWidth: 1.7524,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1775_11231"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.8032,
    height: 24.8032,
    fill: "white",
    transform: "translate(7.65698 8.43066)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.602d659b997670fd96ca0f0507035e6d.svg";
export { ForwardRef as ReactComponent };